module.exports = __webpack_public_path__ + "static/media/plusIcon.ad854300.svg";